import { getValue } from '@/libs/functions/getValue'
import goTo from '../../functions/goTo'

// 初始化民生的api
function initApi() {
  console.log('走到了引入api文件的回调')
  try {
    // 下面这段是配合银行调试的，所以先保留了
    /*  window.onpageshow = function (event) {
      if (
        event.persisted ||
        (window.performance && window.performance.navigation.type == 2)
      ) {
        let agent = navigator.userAgent.toLowerCase()
        let iphone = agent.indexOf('iphone')
        if (iphone != -1) {
          window.location.reload()
        }
      }
    } */
    // 调用setTabBar
    window.CMBCJSBridge.setTabBar({ status: '1' })
  } catch (error) {
    console.log('引入api文件-失败')
  }
}

// // 20250724 空港特殊处理  因为libs是公共组件，怕影响
// useEffect(() => {
//   const tenantCode = getUrlParam('tenantCode') || ''
//   // 空港code
//   const kgCode = ['0278', '0789']
//   if (kgCode.includes(tenantCode)) {
//     console.log('进入了设置title')
//     setTimeout(() => {
//       window.CMBCJSBridge.setNavBar({
//         title: '空港易行·休息室',
//         close: false,
//         leftButton: {
//           exist: 'false',
//           name: '返回',
//           func: function () {
//             window.CMBCJSBridge.closeWebView()
//           },
//         },
//       })
//     }, 300)
//   }
// }, [])
const titleTexts: { [key: string]: string } = {
  // '0278': '贵宾厅服务',
  // '0789': '贵宾厅服务',
  // '0507': '龙腾出行·贵宾厅',
  // '0097': '龙腾出行·贵宾厅',
}
// 设置导航栏
function setNavBar(title: string) {
  try {
    const tenantCode = getValue('tenantCode')
    const hash = window.location.hash
    const closePath = ['/verification/auth', '/verification/qrcode', '/goods/template/common/base', '/goods/template/common/GTWM']
    const isClosePath = closePath.some((el) => hash.includes(el))
    window.CMBCJSBridge.setNavBar({
      title: titleTexts[tenantCode] || title,
      close: false,
      leftButton: {
        exist: isClosePath ? 'false' : 'true',
        name: '返回',
        func: function () {
          if (isClosePath) {
            window.CMBCJSBridge.closeWebView()
          } else {
            // 兼容
            if (title.indexOf('贵宾门到门服务') !== -1) {
              window.CMBCJSBridge.closeWebView()
              return
            }
            goTo(-1)
          }
        },
      },
    })
  } catch (error) {
    console.log('调用导航栏api-失败')
  }
}

export default { setNavBar, initApi }
